import { CreateTaskTagDto, TagType, TaskTagDto } from '@sib/api';

export type TagIdsByType = {
  [TagType.Custom]: string[];
  [TagType.Contact]: string[];
  [TagType.Employee]: string[];
};

export const getTagIdsByType = (tags: TaskTagDto[]): TagIdsByType =>
  tags.reduce<TagIdsByType>(
    (acc, t) => {
      if (t.type === TagType.Custom && t.tag?.uuid) {
        return {
          ...acc,
          [TagType.Custom]: [...acc[TagType.Custom], t.tag.uuid],
        };
      }
      if (t.type === TagType.Contact && t.contact?.id) {
        return {
          ...acc,
          [TagType.Contact]: [...acc[TagType.Contact], t.contact.id],
        };
      }
      if (t.type === TagType.Employee && t.employee?.id) {
        return {
          ...acc,
          [TagType.Employee]: [...acc[TagType.Employee], t.employee.id],
        };
      }

      return acc;
    },
    {
      [TagType.Custom]: [],
      [TagType.Contact]: [],
      [TagType.Employee]: [],
    }
  );

export const mapFormTagsToTaskDto = (tags: Record<TagType, string[]>) =>
  Object.entries(tags).reduce<CreateTaskTagDto[]>((acc, curr) => {
    const [tagType, ids] = curr;
    const tagsToAdd = ids.map(id => ({
      id,
      type: tagType as TagType,
    }));

    return [...acc, ...tagsToAdd];
  }, []);
